import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

const STEPS = ['recruit', 'match', 'attendance', 'communicate'] as const

const Features: React.FC = () => {
  const { t } = useLocale()
  const trust = t('features.trust') as string[]

  return (
    <section
      id="functies"
      className="border-y border-border bg-surface-card px-5 py-16 sm:px-8 lg:px-14 lg:py-[88px]"
    >
      <div className="mx-auto max-w-[1280px]">
        <h2 className="text-balance text-center font-display text-[30px] font-bold tracking-display sm:text-[38px]">
          {t('features.title')}
        </h2>
        <p className="mx-auto mt-3.5 max-w-[58ch] text-center text-[17px] text-text-secondary">
          {t('features.subtitle')}
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, index) => (
            <div
              key={step}
              className="rounded-lg border border-border bg-surface-page p-6"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-md bg-clay-100 font-display text-[17px] font-bold text-clay-700">
                {index + 1}
              </div>
              <h3 className="mb-1.5 mt-3.5 font-display text-xl font-semibold">
                {t(`features.${step}.title`)}
              </h3>
              <p className="text-sm leading-relaxed text-text-secondary">
                {t(`features.${step}.description`)}
              </p>
            </div>
          ))}
        </div>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-10 gap-y-3 text-sm text-text-secondary">
          {trust.map((item) => (
            <li key={item}>
              <span aria-hidden>✓</span> {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Features
